import { createService } from 'reservice'
import * as types from '../actionTypes'

export const fetchStatsReports = createService(types.FETCH_STATS_REPORTS)
export const fetchRankingsStats = createService(types.FETCH_RANKINGS_STATS)
export const fetchSaleStats = createService(types.FETCH_SALE_STATS)
export const fetchSeSaleStats = createService(types.FETCH_SE_SALE_STATS)
export const fetchOrderCategoryDistribution = createService(types.FETCH_ORDER_CATEGORY_DISTRIBUTION)
export const fetchPaginationBestsellers = createService(types.FETCH_PAGINATION_BESTSELLERS)
export const fetchSePaginationBestsellers = createService(types.FETCH_SE_PAGINATION_BESTSELLERS)
export const fetchPageViews = createService(types.FETCH_PAGE_VIEWS)
export const fetchServiceDesks = createService(types.FETCH_SERVICE_DESKS)
export const fetchShortcuts = createService(types.FETCH_SHORTCUTS)
export const fetchShortcutSettings = createService(types.FETCH_SHORTCUT_SETTINGS)
export const updateShortcutSettings = createService(types.UPDATE_SHORTCUT_SETTINGS)
export const fetchPromotions = createService(types.FETCH_PROMOTIONS)

// dashboard
export const fetchSalesPerformances = createService(types.FETCH_SALES_PERFORMANCES)
export const fetchSearchKeywords = createService(types.FETCH_SEARCH_KEYWORDS)
export const fetchListingPageViews = createService(types.FETCH_LISTING_PAGE_VIEWS)
export const fetchSeListingPageViews = createService(types.FETCH_SE_LISTING_PAGE_VIEWS)
export const fetchReturns = createService(types.FETCH_RETURNS)
export const fetchReturnReasonSummaries = createService(types.FETCH_RETURN_REASONS)
export const fetchSpecificReturnReasonsListings = createService(types.FETCH_SPECIFIC_RETURN_REASONS_LISTINGS)
export const fetchSpecificSearchKeywordListings = createService(types.FETCH_SPECIFIC_SEARCH_KEYWORD_LISTINGS)
export const fetchAbandonedCarts = createService(types.FETCH_ABANDONED_CARTS)
export const fetchArrivalNoticeSummaries = createService(types.FETCH_ARRIVAL_NOTICE_SUMMARIES)
export const fetchListingTags = createService(types.FETCH_LISTING_TAGS)
export const fetchMemberAnalyses = createService(types.FETCH_MEMBER_ANALYSES)
export const fetchSaleStatsByDate = createService(types.FETCH_SALE_STATS_BY_DATE)
export const fetchSeSaleStatsByDate = createService(types.FETCH_SE_SALE_STATS_BY_DATE)
export const fetchTrackListings = createService(types.FETCH_TRACK_LISTINGS)
export const createTrackListings = createService(types.CREATE_TRACK_LISTINGS)
export const updateTrackListings = createService(types.UPDATE_TRACK_LISTINGS)
export const fetchProductBundles = createService(types.FETCH_PRODUCTS_BUNDLES)
export const createSupplierCoupons = createService(types.CREATE_SUPPLIER_COUPONS)

export const fetchInventories = createService(types.FETCH_INVENTORIES)
export const fetchExpiringItems = createService(types.FETCH_EXPIRING_ITEMS)
export const fetchUnsalableItems = createService(types.FETCH_UNSALABLE_ITEMS)
export const fetchWarehouseOverview = createService(types.FETCH_WAREHOUSE_OVERVIEW)
export const fetchBrandDistribution = createService(types.FETCH_BRAND_DISTRIBUTION)
export const fetchBrandDistributionByBrandId = createService(types.FETCH_BRAND_DISTRIBUTION_BY_BRAND_ID)
